import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  query: '',
  results: null,
  loading: false,
  error: null,
  lastSearchedAt: null,
};

const aiSearchSlice = createSlice({
  name: 'aiSearch',
  initialState,
  reducers: {
    setQuery: (state, action) => {
      state.query = action.payload ?? '';
    },
    setResults: (state, action) => {
      state.results = action.payload;
      state.error = null;
      state.loading = false;
      state.lastSearchedAt = Date.now();
    },
    setLoading: (state, action) => {
      state.loading = Boolean(action.payload);
      if (state.loading) {
        state.error = null;
      }
    },
    setError: (state, action) => {
      state.error = action.payload ?? null;
      state.loading = false;
    },
    clearResults: (state) => {
      state.results = null;
      state.error = null;
      state.loading = false;
      state.lastSearchedAt = null;
    },
  },
});

export const {
  setQuery,
  setResults,
  setLoading,
  setError,
  clearResults,
} = aiSearchSlice.actions;

export const selectAISearchQuery = (state) => state.aiSearch.query;
export const selectAISearchResults = (state) => state.aiSearch.results;
export const selectAISearchLoading = (state) => state.aiSearch.loading;
export const selectAISearchError = (state) => state.aiSearch.error;
export const selectAISearchLastSearchedAt = (state) =>
  state.aiSearch.lastSearchedAt;

export default aiSearchSlice.reducer;
